import React from "react";
import "./../style/offers.css";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";
import CategoryWhyChooseUs from "../category-components/CategoryWhyChooseUs";
import { Link } from "react-router-dom";


const Offers = () => {
  return (
    <>
      <SeoHelmet page="offers" />
      <BreadcrumbBanner
        title="Offer"
        backgroundImage="/Images/banner-about.jpg"
      />
      <section className="bogo-deal-section">
        <div className="bogo-deal-image">
          <img src="/Images/offer1.webp" alt="bogo Deal" loading="lazy"/>
        </div>

        <div className="bogo-deal-content">
          <h2>Daily BOGO Coffee Deal at Mandurah Cafe</h2>
          <h3>Buy One Coffee, Get One FREE – Before 9:00 AM!</h3>

          <p>
            Kickstart your mornings with our exclusive{" "}
            <strong>Buy One Get One Free Coffee</strong> offer, available every
            day <strong>before 9:00 AM</strong> at Mandurah Cafe!
          </p>
          <p>
            Whether you’re heading to work, catching up with a friend, or just
            need your caffeine fix, we’ve got your mornings covered with rich
            aroma and unbeatable value.
          </p>

          <ul>
            <li>
              ✅ Valid every day, <strong>before 9:00 AM only</strong>
            </li>
            <li>
              ✅ Available for <strong>takeaway or dine-in</strong>
            </li>
            <li>✅ Freshly brewed, locally loved, and always satisfying!</li>
          </ul>

          <p className="bogo-deal-cta-text">
            <span className="highlight-red">📍 Visit Mandurah Cafe</span> or{" "}
            <span className="highlight-red">📞 call us</span> to grab your
            morning BOGO deal –
            <strong>
              {" "}
              it’s the perfect way to double your energy, every day!
            </strong>
          </p>

          <Link to="/contact-us" ><button className="bogo-deal-button">Contact Us</button> </Link>
        </div>
      </section>
          <section className="offer-image-section">
        <h2 className="offer-title">BOGO Offer</h2>
        <div className="offer-image-wrapper">
          <img
            src="/Images/offer-1.png"
            alt="BOGO Offer"
            className="offer-full-image"
            loading="lazy"
          />
        </div>
 
      </section>
      <CategoryWhyChooseUs/>
    </>
  );
};

export default Offers;
